export enum Language {
  portuguese = 'pt',
  english = 'en',
  spanish = 'es',
}
